export const jkoaPurchaseReducer = (state = false, action) => {
    switch (action.type) {
        case 'JKOA_ITEM_YES':
            return true;
        case 'JKOA_ITEM_NO':
            return false;
        default:
            return state;
    }
};